import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {
  CustomAutocomplete,
  CustomSearch,
  CustomTextField,
  EstadoComponente,
  SingleButton,
} from "@/shared/components/ui";
import {
  useUpdateTiketUser,
  usefetchTiketUsers,
} from "@/shared/actions/erp/tiketUsers";
import { useCheckPermissions, useTableFilter } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  EstadosTiketUserEnum,
  MotivoRechazo,
  TiketUsers,
} from "@/shared/interfaces";
import { Avatar, Box, Grid, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useForm } from "react-hook-form";
import DeleteIcon from "@mui/icons-material/Delete";
import { useFetchMotivosRechazo } from "@/shared/actions/erp";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { useUiStore } from "@/store/ui";
import { PermissionsEnum } from "@/auth/interfaces";

const returnUrlTU = "/tikets/usuarios-tikets";

type SaveFormData = {
  descripcion: string;
  motivo_rechazo: string;
  observaciones: string;
};
export default function TiketsUsuariosEnesperasPagina() {
  useCheckPermissions(PermissionsEnum.api_view_ticketuser);

  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const updateTiketUser = useUpdateTiketUser({navigate, returnUrl:returnUrlTU});
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [idEdit2, setIdEdit2] = useState<string | null>(null);
  const [idEdit, setIdEdit] = useState<string| null>(null);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);

  function onActions(e: MRT_RowData) {
    setIdEdit2(e.id_ticketuser);
    setIsModalOpen2(true);
  }
  function onActions2(e: MRT_RowData) {
    setIdEdit(e.id_ticketuser);
    setIsModalOpen3(true);
  }
  const columns = useMemo<MRT_ColumnDef<TiketUsers>[]>(
    () => [
      {
        accessorKey: "codigo",
        header: "codigo",
        size: 200,
      },
      {
        accessorKey: "descripcion",
        header: "descripcion",
        size: 200,
      },
      {
        accessorKey: "empresa_data.razon_social",
        header: "empresa",
        size: 200,
      },
      {
        accessorKey: "area_data.nombre",
        header: "area",
        size: 200,
      },
      {
        accessorKey: "estado_ticket",
        header: "estado",
        size: 200,
        Cell: ({ row }) => (
          row.original.estado_ticket != null ?
            <EstadoComponente backgroundColor="blue" texto={row.original.estado_ticket || ''} /> : null
        ),
      },
      {
        accessorKey: "imagenes.photosTicket",
        header: "imagen 1",
        size: 200,
        Cell: ({ row }) => {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {row.original.imagenes?.photosTicket?.imagen1 && (
                <Avatar
                  sx={{
                    height: 40,
                    width: 40,
                  }}
                  src={row.original.imagenes?.photosTicket?.imagen1.url}
                  alt="imagen 1"
                />
              )}
            </Box>
          );
        },
      },
      {
        accessorKey: "imagenes.photosTicket",
        header: "imagen 1",
        size: 200,
        Cell: ({ row }) => {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {row.original.imagenes?.photosTicket?.imagen2 && (
                <Avatar
                  sx={{
                    height: 40,
                    width: 40,
                  }}
                  src={row.original.imagenes?.photosTicket?.imagen2.url}
                  alt="imagen 1"
                />
              )}
            </Box>
          );
        },
      },
      {
        accessorKey: "fecha_creacion",
        header: "fecha creacion	",
        size: 200,
      },
      {
        accessorKey: "departamento_data.nombre",
        header: "departamento",
        size: 200,
      },
      {
        header: "acciones",
        size: 200,
        Cell: ({ row }) => {
          return (
            <>
              <SingleButton
                label="APROBAR"
                variant="text"
                color="success"
                onClick={() => onActions2(row.original)}
                startIcon={<PendingActionsIcon />}
              />
              <SingleButton
                label="RECHAZAR"
                variant="text"
                color="error"
                onClick={() => onActions(row.original)}
                startIcon={<DeleteIcon />}
              />
            </>
          );
        },
      },
    ],
    []
  );
  const form = useForm<SaveFormData>();
  const {
    control,
    formState: { errors },
    register,
    handleSubmit,
    setError,
  } = form;

  const onEdit =  handleSubmit((data) => {
    
    if (idEdit) {
      updateTiketUser.mutate(
        {
          id: idEdit!,
          data: {
            estado_ticket: EstadosTiketUserEnum.EN_PROCESO,
            observaciones: data.observaciones,
          },
        },
        {
          onSuccess: () => {
            setIsModalOpen3(false);
            setIdEdit(null);
            form.reset({ observaciones: "" });
          },
          onError: (error) => {
            console.error("Error en la mutación", error);
          },
        }
      );
    }
  });
  const handleDelete = () => {
    setConfirmDialog({
      isOpen: true,
      subtitle: "¿Está seguro que deseas rechazar el ticket seleccionado?",
      title: "Confirmar eliminación",
      onConfirm: () => {
        if (idEdit2) {
          updateTiketUser.mutate(
            {
              id: idEdit2!,
              data: {
                estado_ticket: EstadosTiketUserEnum.RECHAZADO,
                fecha_rechazo: new Date().toISOString(),
                motivo_rechazo: form.getValues().motivo_rechazo,
              },
            },
            {
              onSuccess: () => {
                setConfirmDialogIsOpen(false);
                setIsModalOpen2(false);
                setIsModalOpen3(false);
                form.reset({ motivo_rechazo: "" }); // Limpiar el campo 'motivo_rechazo'
                setIdEdit2(null); // Limpiar el id
                refetch();
              },
              onError: (error) => {
                console.error("Error en la mutación", error);
              },
            }
          );
        } else {
          console.error("idEdit2 is null");
        }
      },
      onClose() {
        setConfirmDialogIsOpen(false);
        setIsModalOpen3(false);
      },
    });
  };
  const { data: MotivoRechazoPaging, isLoading: isLoadingMotivoRechazo } =
    useFetchMotivosRechazo({
      page_size: 600,
    });
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();

  const { pageIndex } = pagination;

  const {
    isLoading,
    data: TiketUserEnesperaRes,
    isRefetching,
    refetch,
  } = usefetchTiketUsers({
    page: pageIndex + 1,
    nombre_requerimento: searchTerm,
    estado_ticket: EstadosTiketUserEnum.ABIERTO,
  });
  const onChangeMotivoRechazo = (value: string) => {
    form.setValue("motivo_rechazo", value);
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text=""
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<TiketUsers>
          columns={columns}
          data={TiketUserEnesperaRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={TiketUserEnesperaRes?.data?.count}
          // // actions
          canDelete={false}
          // crud
          enableColumnActions={false}
          enableEditing={false}
          positionActionsColumn="first"
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Detalles"
        cancelTextBtn="Cerrar"
        onClose={() => setIsModalOpen(false)}
        minWidth="80%"
        contentNode={
          <>
            <Grid container spacing={3}>
              <CustomTextField
                label="Descripcion"
                name="descripcion"
                control={form.control}
                defaultValue={form.getValues().descripcion || ""}
                error={errors.descripcion}
                helperText={errors.descripcion?.message ?? ""}
              />
            </Grid>
          </>
        }
      />
      <ScrollableDialogProps
        open={isModalOpen2}
        title="Rechazar el Ticket"
        cancelTextBtn="Cancelar"
        confirmTextBtn="Rechazar"
        contentNode={
          <>
           <CustomAutocomplete<MotivoRechazo>
              label="Motivo"
              name="motivo_rechazo"
              // options
              options={MotivoRechazoPaging?.data.data as any || []}
              valueKey="nombre" // name is the fk
              actualValueKey="codigo"
              defaultValue={form.getValues().motivo_rechazo || ""}
              isLoadingData={isLoadingMotivoRechazo}
              control={control}
              error={errors.motivo_rechazo}
              helperText={errors.motivo_rechazo?.message}
              onChangeValue={onChangeMotivoRechazo}
              optionLabelForEdit={
                MotivoRechazoPaging?.data.data
                  .find((z) => z.codigo === form.getValues().motivo_rechazo)
                  ?.id_motivo_rechazo?.toString() || ""
              }
            />
          </>
        }
        onConfirm={() => {
          if (!form.getValues().motivo_rechazo) {
            setError("motivo_rechazo", {
              type: "required",
              message: "El motivo del rechazo es obligatorio"
            });
            return;
          }
          handleDelete()
        }
      }
        onClose={() => setIsModalOpen2(false)}
      />
      <ScrollableDialogProps
        open={isModalOpen3}
        title="Aprobar el ticket"
        confirmTextBtn="Aprobar"
        contentNode={
          <>
            <TextField
  {...register("observaciones", { required: "La observacion es obligatoria" })}
  id="observaciones"
  label="Observación"
  fullWidth
  rows={4}
  multiline
  error={Boolean(errors.observaciones)}
  helperText={errors.observaciones?.message}
/>
          </>
        }
        onConfirm={onEdit}
        onClose={() => setIsModalOpen3(false)}
      />
    </Grid>
  );
}
